import { Link } from "react-router-dom";
import ar from "@/i18n/ar.json";

// Thank You page - ALWAYS Spanish, regardless of app language state.
export default function ThankYou() {
  const t = ar.thankYou;

  return (
    <main
      data-testid="thank-you-page"
      className="min-h-[70vh] bg-[#F8F9FA]"
    >
      <div className="mx-auto max-w-3xl px-5 md:px-8 py-20 md:py-32 text-center">
        <p
          data-testid="thank-you-eyebrow"
          className="text-xs uppercase tracking-[0.25em] text-[#D4AF37] mb-6"
        >
          {t.eyebrow}
        </p>
        <h1
          data-testid="thank-you-title"
          className="text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.05]"
          style={{ fontFamily: "'Playfair Display', serif", color: "#0D1B2A" }}
        >
          {t.title}
        </h1>
        <p
          data-testid="thank-you-description"
          className="mt-8 text-[#1B263B]/85 text-base md:text-lg leading-relaxed max-w-2xl mx-auto"
        >
          {t.description}
        </p>
        <p
          data-testid="thank-you-note"
          className="mt-4 text-[#1B263B]/65 text-sm leading-relaxed max-w-2xl mx-auto"
        >
          {t.note}
        </p>

        <div className="mt-12">
          <Link
            to="/"
            data-testid="thank-you-back-home"
            className="inline-flex items-center justify-center h-12 px-8 bg-[#0D1B2A] text-white text-xs font-semibold uppercase tracking-widest hover:bg-[#1B263B] no-underline"
          >
            {t.backHome}
          </Link>
        </div>
      </div>
    </main>
  );
}
